"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Input = styled_components_1.default.input `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  align-items: center;
  border-radius: ${({ theme }) => theme.utils.radius};
  display: flex;
  font-size: 1rem;
  line-height: 1.15rem;
  justify-content: center;
  vertical-align: text-bottom;
  font-weight: normal;
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  padding: ${({ theme }) => `${theme.spacings.xs} ${theme.spacings.m}`};
  background-color: ${({ theme }) => theme.colors.whiteBase};
  box-shadow: none;
  outline: none;
  &::-webkit-input-placeholder,
  &::placeholder,
  &::-moz-placeholder,
  &:-ms-input-placeholder,
  &:-moz-placeholder {
    color: ${({ theme }) => theme.colors.greyLighten70};
  }

  width: 100%;
`;
//# sourceMappingURL=input.js.map